import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.factoringProfileSuccess"],
  action => action
);
